import ModalLogisticCreate from './ModalLogisticCreate';
import ModalLogisticDelete from './ModalLogisticDelete';
import ModalLogisticFilter from './ModalLogisticFilter';
import ModalLogisticOrigin from './ModalLogisticOrigin';
import ModalLogisticUpdate from './ModalLogisticUpdate';

export default Object.assign(
  {},
  {
    Create: ModalLogisticCreate,
    Update: ModalLogisticUpdate,
    Delete: ModalLogisticDelete,
    Filter: ModalLogisticFilter,
    Origin: ModalLogisticOrigin,
  },
);
